import { render, staticRenderFns } from "./ProductContextMenu.vue?vue&type=template&id=273b7e76&scoped=true&"
import script from "./ProductContextMenu.vue?vue&type=script&lang=js&"
export * from "./ProductContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductContextMenu.vue?vue&type=style&index=0&id=273b7e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b7e76",
  null
  
)

export default component.exports